import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    data: [],
    availableOptions: ["Assessment", "Treatment", "Coordination", "All"],
    primary: {
      id: null,
      name: "",
      private: false,
      editing: {
        name: "",
        id: null,
        private: false,
      },
    },
    tmp: null,
    childService: {
      id: null,
      name: "",
      parent_id: null,
      options: [],
      type: false,
    },
    pagination: {
      current: null,
      total: null,
      data: [],
    },
  },
  mutations: {
    SET_DATA: (state, data) => {
      let fetchedData = [];
      data.filter((d) => {
        fetchedData.push({
          name: d.name,
          id: d.id,
          private: d.private,
          sub: d.children,
        });
      });
      state.data = fetchedData;
    },
    SET_PAGINATION: (state, payload) => {
      let fetchedData = [];
      payload.data.filter((d) => {
        fetchedData.push({
          name: d.name,
          id: d.id,
          private: d.private,
          sub: d.children,
        });
      });
      state.pagination = {
        total: payload.total,
        current: payload.current,
        data: payload.append
          ? [...state.pagination.data, ...fetchedData]
          : fetchedData,
      };
    },
    PUSH_NEW_DATA: (state, data) => {
      let primary = {
        id: data.id,
        name: data.name,
        private: data.private,
        sub: data.children,
        options: [],
        parent_id: null,
      };

      state.data.push(primary);
      state.pagination.data.push(primary);
      (state.pagination.total = state.pagination.total + 1),
        (state.primary.name = "");
      state.primary.private = false;
    },
    DELETE_PRIMARY_SERVICE: (state, id) => {
      state.data = state.data.filter((item) => item.id != id);
      state.pagination.data = state.pagination.data.filter(
        (item) => item.id != id
      );
      state.pagination.total = state.pagination.total - 1;
    },
    PUSH_NEW_CHILD_DATA: (state, data) => {
      state.pagination.data.filter((d) => {
        if (data.parent_id == d.id) {
          state.childService.name = "";
          state.childService.options = [];
          state.parent_id = null;
          d.sub.push(data);
        }
      });
    },
    DELETE_CHILD_SERVICE: (state, data) => {
      state.data.filter((item) => {
        if (item.id == data.parent_id) {
          let subIndex = -1;
          item.sub.forEach((subItem, index) => {
            if (subItem.id == data.id) {
              subIndex = index;
            }
          });
          if (subIndex > -1) {
            item.sub.splice(subIndex, 1);
          }
        }
      });
      state.pagination.data.filter((item) => {
        if (item.id == data.parent_id) {
          let subIndex = -1;
          item.sub.forEach((subItem, index) => {
            if (subItem.id == data.id) {
              subIndex = index;
            }
          });
          if (subIndex > -1) {
            item.sub.splice(subIndex, 1);
          }
        }
      });
    },
    CANCEL_EDITING: (state) => {
      state.childService = {
        id: null,
        name: "",
        parent_id: null,
        options: [],
        type: false,
      };

      state.primary.editing = {
        name: "",
        id: null,
        private: false,
      };
    },
  },
  actions: {
    all: function ({ commit }, saveLoadState) {
      if (saveLoadState) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      this.$http.get("services").then((res) => {
        if (res.status == 200) {
          commit("SET_DATA", res.data);
          if (saveLoadState) {
            commit("SET_LOADING_STATE", false, { root: true });
          }
        }
      });
    },
    allPaginated: function ({ commit, dispatch, state }, payload) {
      let url = "services";
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
      }
      if (!payload || !payload.page) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: res.data.data,
                  append: true,
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DATA", res.data);
              }
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_LOADING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    addPrimaryService: function ({ commit, dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        if (!(payload.name || "").trim()) {
          dispatch(
            "setError",
            {
              message: "Service name can't be empty",
              title: "Validation Error",
            },
            { root: true }
          );
          return resolve();
        }
        vm.$http
          .post("services", {
            name: payload.name,
          })
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              commit("PUSH_NEW_DATA", res.data.data.service);
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    updatePrimaryService: function ({ commit, state, dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        if (!(payload.name || "").trim()) {
          dispatch(
            "setError",
            {
              message: "Service name can't be empty",
              title: "Validation Error",
            },
            { root: true }
          );
          return resolve();
        }
        vm.$http
          .put(`services/${payload.id}`, {
            name: payload.name,
          })
          .then((res) => {
            if (res.status == 200) {
              state.data.filter((s) => {
                if (s.id == payload.id) {
                  s.name = payload.name;
                }
              });
              state.pagination.data.filter((s) => {
                if (s.id == payload.id) {
                  s.name = payload.name;
                }
              });
              commit("SET_SAVING_STATE", false, { root: true });
              commit("CANCEL_EDITING");
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    deletePrimaryService: function ({ commit }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`services/${payload.id}`)
          .then((res) => {
            if (res.status == 200) {
              Swal.fire({
                title: "Success",
                text: "Service Deleted Successfully",
                type: "success",
              });
              commit("CANCEL_EDITING");
              commit("DELETE_PRIMARY_SERVICE", payload.id);
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            Swal.fire({
              title: "Error",
              text: ((err.data || {}).error || err.error || {}).message,
              type: "error",
            });
            return resolve(false);
          });
      });
    },
    saveChildService: function ({ commit, dispatch }, payload) {
      if (!(payload.name || "").trim()) {
        dispatch(
          "setError",
          {
            message: "Service name can't be empty",
            title: "Validation Error",
          },
          { root: true }
        );
        commit("SET_SAVING_STATE", false, { root: true });
        return;
      }
      if (payload.type == "creating") {
        this.$http
          .post(`services/${payload.parent_id}`, {
            name: payload.name,
            parent_id: payload.parent_id,
            options: payload.options,
          })
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              commit("PUSH_NEW_CHILD_DATA", res.data.data.service);
            }
          });
      } else if (payload.type == "editing") {
        this.$http
          .put(`services/${payload.parent_id}/${payload.id}`, {
            name: payload.name,
            id: payload.id,
            options: payload.options,
          })
          .then((res) => {
            if (res.status == 200) {
              commit("SET_SAVING_STATE", false, { root: true });
              commit("CANCEL_EDITING");
            }
          });
      }
    },
    deleteChildService: function ({ commit }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .delete(`services/${payload.id}`)
          .then((res) => {
            if (res.status == 200) {
              Swal.fire({
                title: "Success",
                text: "Sub Service Deleted Successfully",
                type: "success",
              });
              commit("CANCEL_EDITING");
              commit("DELETE_CHILD_SERVICE", payload);
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            Swal.fire({
              title: "Error",
              text: ((err.data || {}).error || err.error || {}).message,
              type: "error",
            });
            return resolve(false);
          });
      });
    },
    updateServicePrivacy: function (_, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`service-privacy/${payload.id}`, {
            private: payload.private || false,
          })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            Swal.fire({
              title: "Error",
              text: ((err.data || {}).error || err.error || {}).message,
              type: "error",
            });
            return resolve(false);
          });
      });
    },
  },
};
